import { render, staticRenderFns } from "./TooltipIcon.vue?vue&type=template&id=6ac12b14"
import script from "./TooltipIcon.vue?vue&type=script&lang=js"
export * from "./TooltipIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports